module.exports = __webpack_public_path__ + "img/Jump Casting51.14a522a0.jpg";